import { Box, Flex, Switch, Text } from '@chakra-ui/react'

import { Spinner } from '@/components/ui'

interface EnableTailgateBoxIProps {
  isDisabled: boolean
  isEnabled: boolean
  isLoading: boolean
  onToggleChange: (isTailgateEnabled: boolean) => void
}

export const EnableTailgateBox = ({
  isDisabled,
  isEnabled,
  isLoading,
  onToggleChange,
}: EnableTailgateBoxIProps) => {
  const title = isEnabled ? 'Tailgate Enabled' : 'Enable Tailgate'
  const description = isDisabled
    ? 'Requires camera grids to be configured'
    : 'Detect when unauthorized persons follow through doors'
  return (
    <Flex
      alignItems='center'
      border='1px solid #cccccc'
      borderRadius='10px'
      justifyContent='space-between'
      opacity={isDisabled ? 0.5 : 1}
      position='relative'
      px='12px'
      py='12px'
    >
      <Box>
        <Text fontWeight={500}>{title}</Text>
        <Text>{description}</Text>
      </Box>
      <Flex alignItems='center' gap='20px'>
        {isLoading && <Spinner size='md' />}
        <Switch
          isChecked={isEnabled}
          isDisabled={isLoading || isDisabled}
          onChange={(e) => onToggleChange(e.target.checked)}
          sx={{
            '.chakra-switch__track': {
              bg: isEnabled ? '#2fb2b0' : 'components.switch.inactive',
            },
          }}
        />
      </Flex>
    </Flex>
  )
}
